export const tl = t =>
  t === 'movie' ? '◉ Film' : t === 'book' ? '◎ Book' : '◈ Product';

export const metaOf = i => `${i.year} · ${i.by}`;

export const scoreColor = s =>
  s >= 93 ? 'var(--green)' : s >= 80 ? 'var(--amber)' : 'var(--rose)';

export const starsStr = n => {
  const f = Math.floor(n);
  return '★'.repeat(f) + (n % 1 >= 0.5 ? '½' : '') + '☆'.repeat(5 - Math.ceil(n));
};
